import { Injectable } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { ColDef } from 'ag-grid-community';

@Injectable()
export class UserPermissionsGridsService {
  readonly colDefs: ColDef[] = [
    {
      field: 'PermissionID',
      headerName: 'PermissionsGrid.PermissionId',
      type: [ColumnType.Id],
      initialHide: true,
    },
    {
      field: 'Name',
      headerName: 'PermissionsGrid.Permission',
      type: [ColumnType.Text],
      flex: 1,
      hide: true,
    },
    {
      field: 'TranslationKey',
      headerName: 'PermissionsGrid.Description',
      type: [ColumnType.TranslatedText],
      flex: 1,
    },
  ];
}
